import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import { empty, GradeSyncJobStatus } from '../firestore/GradeSyncJob/schema'
import type { FirestoreGradeSyncJob } from '../firestore/GradeSyncJob'

export class GradeSyncJob extends ObservableModelWithDecorators<FirestoreGradeSyncJob> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreGradeSyncJob>
  ) {
    super(repository, doc)
  }

  get isCompleted() {
    return this.data.status === GradeSyncJobStatus.completed
  }

  get isFailed() {
    return this.data.status === GradeSyncJobStatus.failed
  }

  get isPending() {
    return (
      this.data.status === GradeSyncJobStatus.pending ||
      this.data.status === GradeSyncJobStatus.running ||
      this.data.status === GradeSyncJobStatus.continuing
    )
  }
}
